import { render, staticRenderFns } from "./CatalogShow.vue?vue&type=template&id=668d2abc&"
import script from "./CatalogShow.vue?vue&type=script&lang=ts&"
export * from "./CatalogShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports